var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80469 8.23721L14.0005 13.8344L25.1963 8.23721C25.1548 7.52383 24.8422 6.85329 24.3224 6.36293C23.8027 5.87256 23.1151 5.59948 22.4005 5.59961H5.60049C4.88591 5.59948 4.19831 5.87256 3.67854 6.36293C3.15876 6.85329 2.84613 7.52383 2.80469 8.23721Z",
    fill: "#06D6A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1998 11.3652L13.9998 16.9652L2.7998 11.3652V19.6C2.7998 20.3426 3.0948 21.0548 3.61991 21.5799C4.14501 22.105 4.8572 22.4 5.5998 22.4H22.3998C23.1424 22.4 23.8546 22.105 24.3797 21.5799C24.9048 21.0548 25.1998 20.3426 25.1998 19.6V11.3652Z",
    fill: "#06D6A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c27dfd1623341bc81a7b278c58c806cf.svg";
export { ForwardRef as ReactComponent };